import React from 'react'
import { branch, renderNothing } from 'recompose'

import Modal from '@components/Modal'

import Cookies from './Cookies'
import { showCookiesModalSelector } from 'cookies/selectors'
import { cookiePolicyUrlSelector } from 'wordpress/selectors'

import styles from './styles.module.scss'

const $CookieModal = ({ cookiePolicyUrl, translate: t }) => (
    <Modal outsideClickDisabled className={styles.cookieModal} size="large" header={t('cookie.modal.title')}>
        <p>
            <T>cookie.modal.description.1</T>
        </p>
        <p>
            <T>cookie.modal.description.2</T>
            <a target="__blank" href={cookiePolicyUrl}>
                <T>cookie.modal.description.link</T>
            </a>
        </p>
        <Cookies />
    </Modal>
)
const CookieModal = branch(({ showCookieModal }) => !showCookieModal, renderNothing)($CookieModal)

export default compose(
    withTranslate,
    connect(
        createStructuredSelector({
            showCookieModal: showCookiesModalSelector,
            cookiePolicyUrl: cookiePolicyUrlSelector,
        })
    )
)(CookieModal)
